import { ComboBox } from "@progress/kendo-react-dropdowns";
import { useSelectedComponent } from "../../../../Hooks/Display/useComponents";
import { useComponentProperties, useFetchedValues } from "../../../../Hooks/Display/useComponentProperties";
import { useEffect, useState } from 'react';
import { byAttributeName } from "../../utils";

const ResourceProperty = () => {

    const selectedComponent = useSelectedComponent();

    const [properties, setProperty] = useComponentProperties();

    const [{ generalProperties: fetchedValues }] = useFetchedValues();

    const [resourceAttributes, setResourceAttributes] = useState([]);

    useEffect(() => {
        if (fetchedValues.attributes && fetchedValues.attributes.length > 0) {
            const resourceAttributes = fetchedValues.attributes
                .filter(attribute => !attribute.isSystemAttribute && attribute.attributeType === "User Identity")
                .sort(byAttributeName);
            setResourceAttributes(resourceAttributes)
        }
    }, [fetchedValues.attributes])

    const handleResourcePropertyChange = (e) => {
        const resourceAttribute = e.target.value && e.target.value._id ? e.target.value : { _id: "" };
        setProperty("resourceAttribute", resourceAttribute);
    }

    return (
        <div className="clearBtn">
            <ComboBox
                className="w-100 select-overflow "
                disabled={selectedComponent.hidden}
                onChange={handleResourcePropertyChange}
                value={properties.resourceAttribute}
                textField='attributeName'
                data={resourceAttributes}
                dataItemKey='_id'
            />
        </div>
    )
}

export default ResourceProperty;